<template>
  <section v-loading.fullscreen.lock="loading">
    <div class="term5">
      <div class="term5-content">
        <el-table
          :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
          :data="data"
          stripe
          border
          style="width: 100%"
        >
          <el-table-column prop="code" label="代码" width="90">
            <template slot-scope="scope">
              <span class="text-center">{{ scope.row.code }}</span>
            </template>
          </el-table-column>
          <el-table-column width="320" prop="name" label="指标名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
              <el-tooltip
                v-if="scope.row.desc && scope.row.desc != ' '"
                effect="light"
                placement="left"
              >
                <div slot="content">
                  {{ scope.row.desc }}
                </div>
                <svg
                  t="1647934656452"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3085"
                  width="16"
                  height="16"
                  @click="handleOpen(scope.row.desc)"
                >
                  <path
                    d="M512 149.333333A362.666667 362.666667 0 1 1 149.333333 512 363.093333 363.093333 0 0 1 512 149.333333M512 85.333333a426.666667 426.666667 0 1 0 426.666667 426.666667A426.666667 426.666667 0 0 0 512 85.333333z"
                    fill="#2f82ff"
                    p-id="3086"
                  />
                  <path
                    d="M469.333333 672a31.573333 31.573333 0 0 1-22.613333-9.386667l-128-128a32 32 0 0 1 45.226667-45.226666L469.333333 594.773333l213.333334-213.333333A32 32 0 0 1 725.333333 426.666667l-234.666666 234.666666a31.573333 31.573333 0 0 1-21.333334 10.666667z"
                    fill="#2f82ff"
                    p-id="3087"
                  />
                </svg>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="uom" label="单位" width="90">
            <template slot-scope="scope">
              <span class="text-center">{{ scope.row.uom }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="value1" label="数值">
            <template slot-scope="scope" inline-template>
              <section v-if="scope.row.code == 61">
                <span class="text-center">{{ kzy ? kzy : scope.row.value1 }}</span>
              </section>
              <section v-else-if="scope.row.code == 622">
                <span class="text-center">{{ kzy_price ? kzy_price : scope.row.value5 }}</span>
              </section>
              <section
                v-else-if="scope.row.equipstandardopt.viewOnly[0] == false"
              >
                <el-select
                  v-if="scope.row.equipstandardopt.optional"
                  v-model="scope.row.value1"
                  disabled
                  placeholder="请选择"
                  @change="
                    handleValue(scope.row.value1, scope.$index, scope.row)
                  "
                >
                  <el-option
                    v-for="item in scope.row.equipstandardopt.optional"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value"
                  />
                </el-select>
                <el-input
                  v-else
                  v-model="scope.row.value1"
                  placeholder=""
                  disabled
                  @input="
                    scope.row.code == 6104 ||
                      scope.row.code == 62101 ||
                      scope.row.code == 6321
                      ? handleNumber1(scope.row)
                      : handleNumber(scope.row.value1)
                  "
                  @change="
                    handleValue(
                      scope.row.value1,
                      scope.$index,
                      scope.row,
                      scope
                    )
                  "
                  @focus="
                    handleValue(
                      scope.row.value1,
                      scope.$index,
                      scope.row,
                      scope
                    )
                  "
                />
              </section>
              <section v-else>
                <span class="text-center">—</span>
              </section>
            </template>
          </el-table-column>
          <el-table-column prop="logic" label="取值逻辑">
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.logic"
                effect="light"
                placement="top">
                <div slot="content">
                  {{ scope.row.logic }}
                </div>
                <span class="logic" @click="handleOpen(scope.row.logic)">{{
                  scope.row.logic
                }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </section>
</template>
<script>
import api from '@/api/app'
import mock from '@/utils/mock'
export default {
  name: 'ComTerm15',
  components: {},
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      loading: false,
      name: '',
      phone: '',
      statisticsInfo: mock.statistics.statistics.viewInfo,
      statisticsInit: mock.statistics.statistics.init,
      form: [],
      jsonForm: {},
      t: null,
      kzy: null,
      kzy_price: null,
      liuer: null,
      liusan: null,
      pushArr: true
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.handleOthers()
    if (localStorage.getItem('form6')) {
      this.form = JSON.parse(localStorage.getItem('form6'))
    }
  },
  methods: {
    handleOthers() {
      var c = this.handleValueModle(
        0,
        0,
        this.liuer,
        62,
        323,
        '6.2 当年更新课桌椅情况 ',
        '指统计年度配备的课桌椅数量及经费情况。',
        '',
        {
          code: 62,
          hisIdx: [''],
          id: 323,
          names: ['数值'],
          optional: null,
          readOnly: [true],
          viewOnly: [true],
          year: 2022
        },
        ''
      )

      var d = this.handleValueModle(
        0,
        0,
        this.liusan,
        63,
        329,
        '6.3 校服基本情况',
        '',
        '',
        {
          code: 63,
          hisIdx: [''],
          id: 329,
          names: ['数值'],
          optional: null,
          readOnly: [true],
          viewOnly: [true],
          year: 2022
        },
        ''
      )
    },
    compare(attr) {
      return function(a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val1 - val2
      }
    },
    arrayLookup(data, key, value, targetKey) {
      var targetValue = ''
      for (var i = 0; i < data.length; i++) {
        if (data[i][key] == value) {
          targetValue = data[i][targetKey]
          break
        }
      }
      return targetValue
    },
    handleValue(x, y, z, a) {
      var isExit = false
      var obj = {}
      obj.code = z.code
      obj.id = z.id
      obj.name = z.name
      obj.desc = z.desc
      obj.uom = z.uom
      obj.equipstandardopt = z.equipstandardopt
      obj.logic = z.logic
      obj.value1 = z.value1
      obj.value2 = null
      obj.value3 = null
      obj.value4 = null
      obj.value5 = null
      obj.value6 = null
      if (obj.code == 6103) {
        localStorage.setItem('6103', obj.value1)
      } else if (obj.code == 621) {
        localStorage.setItem('621', obj.value1)
      } else if (obj.code == 632) {
        if (obj.value1 == 5) {
        }
      }
      for (var i = 0; i < this.form.length; i++) {
        if (this.form[i].id == z.id) {
          this.form[i].value1 = z.value1
          isExit = true
          break
        }
      }
      if (!isExit) {
        this.form.push(obj)
      }
      console.log(this.form, 'this.form')
      var a = this.handleValueModle(
        6101,
        6102,
        this.kzy,
        61,
        318,
        '6.1 课桌椅总数',
        '包括单人课桌椅和双人课桌椅',
        '套',
        {
          code: 61,
          hisIdx: [''],
          id: 318,
          names: ['数值'],
          optional: null,
          readOnly: [true],
          viewOnly: [false],
          year: 2022
        },
        '6101+6102'
      )
      this.kzy = a
      var b = this.handleValueModle(
        62201,
        62202,
        this.kzy_price,
        622,
        326,
        '6.2.2 当年更新课桌椅经费合计',
        '',
        '元 ',
        {
          code: 622,
          hisIdx: [''],
          id: 326,
          names: ['数值'],
          optional: null,
          readOnly: [true],
          viewOnly: [false],
          year: 2022
        },
        '62201+62202'
      )
      this.kzy_price = b
      if (this.form.length == this.data.length) {
        this.form.sort(this.compare('id'))
        this.toJson()
      }
    },
    handleValueModle(
      code1,
      code2,
      value,
      code,
      id,
      name,
      desc,
      uom,
      equipstandardopt,
      logic
    ) {
      var isExit = false
      var num1 = this.arrayLookup(this.form, 'code', code1, 'value1')
      var num2 = this.arrayLookup(this.form, 'code', code2, 'value1')
      if (code == 62 || code == 63) {
        value = null
      }
      value = Number(num1) + Number(num2)
      if (value || code == 62 || code == 63) {
        const obj1 = {}
        obj1.code = code
        obj1.id = id
        obj1.name = name
        obj1.desc = desc
        obj1.uom = uom
        obj1.equipstandardopt = equipstandardopt
        obj1.logic = logic
        obj1.value1 = value
        obj1.value2 = null
        obj1.value3 = null
        obj1.value4 = null
        obj1.value5 = null
        obj1.value6 = null
        for (var i = 0; i < this.form.length; i++) {
          if (this.form[i].id == id) {
            this.form[i].value1 = value
            isExit = true
            break
          }
        }
        if (!isExit) {
          this.form.push(obj1)
        }
      }
      return value
    },
    toJson() {
      // for(let i of this.form){
      for (let i = 0; i < this.form.length; i++) {
        // let id = i.id
        // let code = i.code
        // let value1 = i.value1
        const id = this.form[i].id
        const code = this.form[i].code
        const name = this.form[i].name
        const desc = this.form[i].desc
        const uom = this.form[i].uom
        const equipstandardopt = this.form[i].equipstandardopt
        const logic = this.form[i].logic
        const value1 = this.form[i].value1
        const value2 = null
        const value3 = null
        const value4 = null
        const value5 = null
        const value6 = null
        this.jsonForm[id] = {
          code,
          name,
          desc,
          uom,
          equipstandardopt,
          logic,
          value1,
          value2,
          value3,
          value4,
          value5,
          value6
        }
      }
      // console.log(JSON.stringify(this.jsonForm));
    },
    handleName(v) {
      if (this.t != null) {
        clearTimeout(this.t)
      }
      this.t = setTimeout(() => {
        var reg = new RegExp('^[\u4e00-\u9fa5]|[a-zA-Z]+$')
        if (!reg.test(v)) {
          this.$message.error('仅支持输入中英文')
          console.log(reg, v)
        }
      }, 800)
    },
    handleNumber1(v) {
      if (this.t != null) {
        clearTimeout(this.t)
      }
      var a = localStorage.getItem('6103')
      var b = localStorage.getItem('621')
      var c = localStorage.getItem('111')
      this.t = setTimeout(() => {
        var reg = new RegExp('^[0-9]*$')
        if (!reg.test(v.value1)) {
          this.$message.error('仅支持输入数字')
        } else {
          if (v.code == 6104) {
            if (v.value1 > a) {
              this.$message.error(`输入数值不得大于${a}`)
              // this.pushArr = false
            }
          } else if (v.code == 62101) {
            if (v.value1 > b) {
              this.$message.error(`输入数值不得大于${b}`)
              // this.pushArr = false
            }
          } else if (v.code == 6321) {
            if (v.value1 > c) {
              this.$message.error(`输入数值不得大于${c}`)
              // this.pushArr = false
            }
          }
        }
      }, 800)
    },
    handleNumber(v) {
      if (this.t != null) {
        clearTimeout(this.t)
      }
      this.t = setTimeout(() => {
        var reg = new RegExp('^[0-9]*$')
        if (!reg.test(v)) {
          this.$message.error('仅支持输入数字')
        }
      }, 800)
    },
    handlePre() {
      this.$emit('pre')
    },
    handleNext() {
      if (this.form.length == this.data.length) {
        this.$emit('next')
      } else {
        this.$message.error('请先填写当前页面，才可进行下一步')
      }
    },
    handleSave() {
      if (this.pushArr == true) {
        if (this.form.length < this.data.length) {
          this.$message.error('保存失败，请填写完整！')
        } else if (this.form.length == this.data.length) {
          this.toJson()
          const obj = {}
          obj.data = JSON.stringify(this.jsonForm)
          console.log(obj, 'obj')
          api.statistics.submit(obj).then((res) => {
            console.log(res)
            if (JSON.parse(localStorage.getItem('form6')) !== this.form) {
              this.$message.success('已保存成功！')
              localStorage.setItem('form6', JSON.stringify(this.form))
            } else if (JSON.parse(localStorage.getItem('form6')) == this.form) {
              this.$message.error('无修改数据！')
            } else {
              this.$message.success('已保存成功！')
              localStorage.setItem('form6', JSON.stringify(this.form))
            }
          })
        }
      } else {
        this.$message.error('保存失败，请仔细校验有取值逻辑的数值是否符合逻辑')
      }
    },
    handleClear() {
      this.$confirm('此操作将永久删除该表格数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          localStorage.removeItem('form6')
          this.$emit('clear')
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    handleOpen(v) {
      this.$alert(v, '查看指标解释', {
        confirmButtonText: '关闭',
        callback: (action) => {}
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.term5 {
  min-height: 720px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  &-top {
    display: inline-block;
    display: flex;
    justify-content: space-between;
    padding-bottom: 25px;
    border-bottom: 1px solid #d7d7d7;
    &-info {
      display: inline-block;
      .el-input {
        width: 62%;
      }
    }
    > span {
      padding: 0px 15px;
      border: 1px solid #d7d7d7;
      line-height: 34px;
      cursor: pointer;
      color: #8b8b8b;
    }
  }
  &-content {
    margin-top: 25px;
    .icon {
      cursor: pointer;
      position: absolute;
      right: 8px;
    }
    .logic {
      cursor: pointer;
    }
  }
}
.term5-top-info /deep/ .el-input__inner {
  height: 34px;
}
.text-center {
  display: block;
  text-align: center;
}
</style>
